module.exports = __webpack_public_path__ + "img/122.32179ed3.jpg";